

export const leapYear = (year) => {
    return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
}

export const getStartDateOfTheYear = (year) => {
    return new Date(year, 0, 2);
}